import { ToneDto, ToneDtoImpl } from '../../core/dto/tonedto';
import { PersistWebData } from '../persist/persistwebdata';
import { WebSessionStorage } from '../persist/websessionstorage';
import { AESEncryptionDecryption } from '../aseencryption';

export class ToneCache
{
    private static TONE_DETAILS: string;
    private static TONE_DETAILS_KEY: string = "*sixdee@IVRTONEDETAILS";
     private persisData: PersistWebData;
     private toneCache: ToneDto | null;

     constructor()
     {
         this.persisData = new WebSessionStorage();
         this.toneCache = new ToneDtoImpl();

         let toneData = this.persisData.getItem(ToneCache.TONE_DETAILS);

         if(toneData !== null)
         {
             (this.toneCache as ToneDtoImpl).fromJson(
                 AESEncryptionDecryption.decryptWithAES(JSON.parse(toneData), ToneCache.TONE_DETAILS_KEY));
         }
     }

     getToneContext(): ToneDto | null
     {
         return this.toneCache;
     }

     updateToneContext(toneCache: ToneDto | null)
     {
         this.toneCache = toneCache;
         
         this.persisData.setItem(ToneCache.TONE_DETAILS, 
            AESEncryptionDecryption.encryptWithAES(JSON.stringify(toneCache), ToneCache.TONE_DETAILS_KEY));
     }

     clearCache()
     {
         this.toneCache = null;
         this.persisData.clear();
     }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/tonedetails/tonecache.ts